<app-search-bar
  [primaryButtonAction]="primaryButtonAction"
  [primaryButtonKey]="'parameters/kakaotalk-templates/add-template-button'"></app-search-bar>
<!-- waiting for BE review (perf) -->
<!-- [searchKey]="'parameters/kakaotalk-templates/search-placeholder'" -->

<app-table [config]="config" [filters]="filters"></app-table>

<ng-template #templateNameRef let-url="url" let-name="name">
  <a [href]="url">{{ name }}</a>
</ng-template>
